import axios from 'axios';

/**
 * The single HTTP client. Every request in the app goes through it — no component calls
 * axios directly (`.claude/rules/frontend.md`).
 *
 * Authentication is the **session cookie and nothing else** (ADR 0003). There is no
 * `Authorization: Bearer` header, no token in `localStorage` and no second mechanism to
 * fall back to: `withCredentials` is what authenticates a request. The template this
 * project started from carried a token path alongside the cookie — the very design ADR
 * 0003 rejected — and it survived here until BUG-013. Do not reintroduce it.
 *
 * The tenant is never sent from here either: the backend resolves it from the
 * authenticated user (`.claude/rules/tenancy.md`).
 */
export const apiClient = axios.create({
  // No prefix: the generated schema's paths are absolute (`/api/v1/...`), and `src/api/http.ts`
  // passes them through verbatim, so a path in the code is the path in the backend's own document.
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
  },
  // Sends the session cookie on same-origin API calls. This is the whole auth mechanism.
  withCredentials: true,
  // Django names its CSRF cookie `csrftoken` and expects it back in `X-CSRFToken`; axios
  // defaults to the `XSRF-TOKEN` / `X-XSRF-TOKEN` pair, which Django never reads. Without
  // these two lines every unsafe request would be refused despite a valid session.
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});
